import { useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header/Header';
import Sidebar from '../components/Sidebar/Sidebar';
import EntityProjectsContext from '../context/EntityProjects.context';
import Documentations from '../../documentations/Documentations';
import Contractualization from '../../contractualizations/Contractualization';
import Organization from '../../organizations/Organization';
import Demonstrative from '../../demonstratives/Demonstrative';
import MedicalScale from '../../medicalscales/MedicalScale';
import ContractAndEdital from '../../contractsandeditals/ContractAndEdital';
import Movement from '../../movements/Movement';
import HumanResource from '../../humanresources/HumanResource';
import Indicators from '../../indicators/Indicators';
import Finances from '../../finances/Finances';
import Emendation from '../../emendations/Emendation';
import SynonymousDescriptions from '../../cbosynonymousdescriptions/SynonymousDescriptions';
import NotFound from '../../notfound/NotFound';
import { useSelector, useDispatch } from 'react-redux';
import Fetch from '../../functions/Fetch';
import config from '../../../../../config/config';
import Home from '../components/Home/Home';
import { IconChevronRight, IconHome } from '@tabler/icons-react';
import { optionsMap } from '../components/Sidebar/sideBarSubMenus';
import { useIndicators } from '../../indicators/hooks/useIndicators';
import Qualification from '../../qualification/Qualification';
import { LoadingSkeletonPage2 } from '../components/Skeleton/LoadingSkeletonPage2';

const Page2 = () => {
    const dispatch = useDispatch();
    const [isLoadingPage, setIsLoadingPage] = useState(true);
    const [activeTab, setActiveTab] = useState('');
    const { indicatorsTabs, isLoading } = useIndicators();
    const [hasProperties, setHasProperties] = useState(false);
    const [hasProjectDocumentations, setHasProjectDocumentations] = useState(false);

    const subMenus = {
        ...optionsMap,
        Documentação: optionsMap.Documentação.filter(
            (option) =>
                option.value !== 'projectdocumentation' ||
                hasProjectDocumentations
        ),
        Organização: optionsMap.Organização.filter(
            (option) => option.value !== 'properties' || hasProperties
        )
    };

    const { friendly_url } = useParams();

    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });

    useEffect(() => {
        const loadData = async () => {
            setIsLoadingPage(true);
            let customData;
            if (sessionSelector.pdc_project_friendly_url || friendly_url) {
                const bodyCustomization = {
                    friendly_url:
                        sessionSelector.pdc_project_friendly_url ||
                        friendly_url,
                    entity: !!!sessionSelector.pdc_project_friendly_url
                };

                customData = await Fetch.post(
                    `${config.endpoints.backend}portal/getcustomizations`,
                    bodyCustomization
                );

                if (customData) {
                    customData.logo =
                        config.endpoints.backend + customData.logo;
                    customData.background_image =
                        config.endpoints.backend + customData.background_image;
                    setInfos({
                        displayMode: customData.theme,
                        primary_color: customData.primary_color,
                        secondary_color: customData.secondary_color,
                        content_color: customData.content_color,
                        bannerURL: customData.background_image,
                        header: {
                            title: 'Plataforma de Transparência',
                            subtitle: customData.entity_name,
                            logoURL: customData.logo
                        },
                        banner: {
                            title: customData.project_name,
                            subtitle: customData.description,
                            description: customData.object
                        }
                    });

                    dispatch({
                        type: 'UPDATE_SESSION',
                        key: 'has_siasus_dashboard',
                        value: customData.has_siasus_dashboard
                    });
                    dispatch({
                        type: 'UPDATE_SESSION',
                        key: 'has_sihsus_dashboard',
                        value: customData.has_sihsus_dashboard
                    });
                    dispatch({
                        type: 'UPDATE_SESSION',
                        key: 'has_samu_dashboard',
                        value: customData.has_samu_dashboard
                    });
                    dispatch({
                        type: 'UPDATE_SESSION',
                        key: 'samu_city_id',
                        value: customData.samu_city_id
                    });

                    dispatch({
                        type: 'UPDATE_SESSION',
                        key: 'primary_color',
                        value: customData.primary_color
                    })
                }

                const menus = await Fetch.post(
                    `${config.endpoints.backend}portal/getmenus`,
                    bodyCustomization
                );
                setProjectsPage2(menus);

                const body = { friendly_url: bodyCustomization.friendly_url };
                const [propertiesResponse, projectDocumentationsResponse] =
                    await Promise.all([
                        Fetch.post(`${config.endpoints.backend}portal/hasproperties`, body),
                        Fetch.post(`${config.endpoints.backend}portal/hasprojectdocumentations`, body)
                    ]);
                setHasProperties(!!(propertiesResponse && propertiesResponse.hasProperties));
                setHasProjectDocumentations(
                    !!(
                        projectDocumentationsResponse &&
                        projectDocumentationsResponse.hasProjectDocumentations
                    )
                );
            }

            setIsLoadingPage(false);
        };

        loadData();
    }, []);

    const {
        infos,
        setInfos,
        setPageToRender,
        pageToRender,
        projectsPage2: projects,
        setProjectsPage2
    } = useContext(EntityProjectsContext);
    const [isClicked, setIsClicked] = useState(false);
    const [menuClicked, setMenuClicked] = useState(null);
    const [previousMenu, setPreviousMenu] = useState(null);

    const classNameByDisplayMode = {
        1: 'display-mode-1',
        2: 'display-mode-2',
        3: 'display-mode-3'
    };

    const onMenuClick = (project) => {
        let activeSubMenu = '';

        if (project.title === 'Indicadores') {
            activeSubMenu = indicatorsTabs[0] ? indicatorsTabs[0].value : null;
        } else {
            activeSubMenu =
                optionsMap[project.title] && optionsMap[project.title][0]
                    ? optionsMap[project.title][0].value
                    : null;
        }
        setMenuClicked(project);
        setActiveTab(activeSubMenu);
        setIsClicked(true);
    };

    const RenderContent = ({ menuClicked }) => {
        const showNav = infos.displayMode !== '3';
        switch (menuClicked.page) {
            case 'documentations':
                setPreviousMenu(null);
                return (
                    <Documentations
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        showNav={showNav}
                        hasProjectDocumentations={hasProjectDocumentations}
                    />
                );
            case 'qualifications':
                setPreviousMenu(null);
                return <Qualification />;
            case 'contractualizations':
                setPreviousMenu(null);
                return (
                    <Contractualization
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        showNav={showNav}
                    />
                );
            case 'organizations':
                setPreviousMenu(null);
                return (
                    <Organization
                        setPreviousMenu={setPreviousMenu}
                        setMenuClicked={setMenuClicked}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        showNav={showNav}
                        hasProperties={hasProperties}
                    />
                );
            case 'demonstratives':
                setPreviousMenu(null);
                return (
                    <Demonstrative
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        showNav={showNav}
                    />
                );
            case 'medicalscales':
                setPreviousMenu(null);
                return <MedicalScale />;
            case 'contractsandeditals':
                setPreviousMenu(null);
                return (
                    <ContractAndEdital
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        showNav={showNav}
                    />
                );
            case 'humanresources':
                return (
                    <HumanResource
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        showNav={showNav}
                    />
                );
            case 'notfound':
                setPreviousMenu(null);
                return <NotFound />;
            case 'movements':
                return <Movement setMenuClicked={setMenuClicked} />;
            case 'indicators':
                setPreviousMenu(null);
                return (
                    <Indicators
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        showNav={showNav}
                        isLoading={isLoading}
                        indicatorsTabs={indicatorsTabs}
                    />
                );
            case 'finances':
                setPreviousMenu(null);
                return (
                    <Finances
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        showNav={showNav}
                    />
                );
            case 'emendations':
                return <Emendation />;
            case 'synonymousdescriptions':
                setPreviousMenu(null);
                return <SynonymousDescriptions />;
            default:
                return <NotFound />;
        }
    };

    return isLoadingPage ? (
        <LoadingSkeletonPage2 infos={infos} />
    ) : (
        <div className="projects-page">
            {infos.displayMode === '3' && (
                <Sidebar
                    onClick={(prj) => onMenuClick(prj)}
                    color={infos.primary_color}
                    projects={projects}
                    logoURL={infos.header.logoURL}
                    menuClicked={menuClicked}
                    onClickLogo={() => {
                        setPageToRender('goback');
                        dispatch({
                            type: 'UPDATE_SESSION',
                            key: 'pdc_project_friendly_url',
                            value: null
                        });
                    }}
                    activeSubMenu={activeTab}
                    setActiveSubMenu={setActiveTab}
                    indicatorsTabs={indicatorsTabs}
                    subMenus={subMenus}
                />
            )}
            <div className={classNameByDisplayMode[infos.displayMode]}>
                <Header
                    mode={infos.displayMode}
                    title={infos.header.title}
                    subtitle={infos.header.subtitle}
                    color={infos.primary_color}
                    logoURL={infos.header.logoURL}
                    onClick={() => {
                        setPageToRender('goback');
                        dispatch({
                            type: 'UPDATE_SESSION',
                            key: 'pdc_project_friendly_url',
                            value: null
                        });
                    }}
                />
                {isClicked ? (
                    <div style={{ overflowY: 'auto' }}>
                        <div
                            className="home-button-container mt-3 mr-4 bg-white"
                            style={{
                                marginLeft: '50px'
                            }}
                        >
                            <a
                                className="c-pointer ml-2"
                                onClick={() => setPageToRender('goback')}
                                style={{ color: infos.primary_color }}
                            >
                                <IconHome size={20} />
                                <span className="ml-3 mr-3">
                                    <IconChevronRight
                                        size={20}
                                        color="#A4A7AE"
                                    />
                                </span>
                            </a>

                            <span
                                className="home-button-previous c-pointer"
                                onClick={() => setIsClicked(false)}
                            >
                                {infos.banner.title}

                                <span className="ml-3 mr-3">
                                    <IconChevronRight
                                        size={20}
                                        color="#A4A7AE"
                                    />
                                </span>
                            </span>

                            {previousMenu && (
                                <span
                                    className="home-button-previous c-pointer"
                                    onClick={() => onMenuClick(previousMenu)}
                                >
                                    {previousMenu.title}

                                    <span className="ml-3 mr-3">
                                        <IconChevronRight
                                            size={20}
                                            color="#A4A7AE"
                                        />
                                    </span>
                                </span>
                            )}

                            <span className="home-button-span">
                                {menuClicked.title}
                            </span>

                            {optionsMap[menuClicked.title] &&
                                optionsMap[menuClicked.title].find(
                                    (option) => option.value === activeTab
                                ) && (
                                    <span
                                        className="home-button-span"
                                        style={{
                                            color: '#181D27',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        <span className="ml-3 mr-3">
                                            <IconChevronRight
                                                size={20}
                                                color="#A4A7AE"
                                            />
                                        </span>
                                        {
                                            optionsMap[menuClicked.title].find(
                                                (option) =>
                                                    option.value === activeTab
                                            ).title
                                        }
                                    </span>
                                )}

                            {indicatorsTabs &&
                                indicatorsTabs.find(
                                    (option) => option.value === activeTab
                                ) && (
                                    <span
                                        className="home-button-span"
                                        style={{
                                            color: '#181D27',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        <span className="ml-3 mr-3">
                                            <IconChevronRight
                                                size={20}
                                                color="#A4A7AE"
                                            />
                                        </span>
                                        {
                                            indicatorsTabs.find(
                                                (option) =>
                                                    option.value === activeTab
                                            ).title
                                        }
                                    </span>
                                )}
                        </div>
                        <RenderContent menuClicked={menuClicked} />
                    </div>
                ) : (
                    <Home
                        title={infos.banner.title}
                        subtitle={infos.banner.subtitle}
                        description={infos.banner.description}
                        imgUrl={infos.bannerURL}
                        color={infos.secondary_color}
                        textColor={infos.content_color}
                        menus={projects}
                        onClick={(prj) => onMenuClick(prj)}
                        mode={infos.displayMode}
                    />
                )}
            </div>
        </div>
    );
};

export default Page2;
